// firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getDatabase } from "firebase/database"; 
const firebaseConfig = {

  apiKey: "AIzaSyAWvVSKTE_Bh-H8_lrAEpXl8te29lVid9g",

  authDomain: "lipmn-ecfdf.firebaseapp.com",

  databaseURL: "https://lipmn-ecfdf-default-rtdb.firebaseio.com",

  projectId: "lipmn-ecfdf",

  storageBucket: "lipmn-ecfdf.firebasestorage.app",

  messagingSenderId: "710864018176",

  appId: "1:710864018176:web:5dea2429b5d8b01e4731e5",

  measurementId: "G-T5F8N6VWCM"

};








// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getDatabase(app); 

// Export the initialized Firebase app
export { app, db };
